import React, { useEffect } from 'react';

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import Hero from "../components/Hero";
import BenefitSection from "../components/BenefitSection";
import Features from "../components/Features";
import CTA from "../components/CTA";
import HowItWorks from "../components/HowItWorks";

import AOS from 'aos';
import 'aos/dist/aos.css';

function IndexPage() {

  useEffect(() => {
    AOS.init({duration: 1200, delay: 200, once:false});
  })    

  return (
    <Layout>
      <SEO title="Home" />
      {/* hero section */}
      <Hero />

      {/* how it works section */}
      <HowItWorks />

      {/* benefits section */}
      <BenefitSection />

      {/* features section */}
      <Features />

      {/* call to action section */}
      <CTA />

    </Layout>
  );
}

export default IndexPage;